'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-dom/index.js
// module id = 33
// module chunks = 0 1 2 3 4 5 6